import { cx } from 'emotion';
import React from 'react';

interface Props {
    data?: { image?: { url: string } }; // TODO: pass only required information, not full data
}

export const ImageModule: React.FC<Props> = ({ data }) => {
    const imgUrl = data?.image?.url || '';

    return (
        <div>
            <img
                className={cx('dc-modules__item--image')}
                data-testid="module-image"
                src={imgUrl}
                width="100%"
            />
        </div>
    );
};
